import join from 'url-join';

import { asyncAction, http } from '../util';

const api = join(import.meta.env.VITE_API_URL, 'v1');

export const fetchNotifications = asyncAction({
  baseName: 'REQUEST_NOTIFICATIONS',
  action: action => () => dispatch => {
    dispatch(action.start());
    return http
      .get(join(api, 'notifications/managable/outages'))
      .then(({ data: response }) => dispatch(action.success(response)))
      .catch(error => dispatch(action.error({ error })));
  }
});

export const fetchCustomNotifications = asyncAction({
  baseName: 'REQUEST_CUSTOM_NOTIFICATIONS',
  action: action => () => dispatch => {
    dispatch(action.start());
    return http
      .get(join(api, 'notifications/custom'))
      .then(({ data: response }) => dispatch(action.success(response)))
      .catch(error => dispatch(action.error({ error })));
  }
});
